import { getMiddlewareUrl } from './getMiddlewareUrl'

/**
 * get redirect from downsell api
 * @param {string} companyId
 */
export const redirectToDownsell = async (companyId) => {
  try {
    const BASE_URL = getMiddlewareUrl()
    const endpoint = '/api/downsell'

    const sanitizedCompanyId = companyId.replace(/"/g, '')
    const resp = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ company_id: sanitizedCompanyId }),
    })

    if (resp && resp.status === 200) {
      const text = await resp.text()
      const redirectUrl = text ? text.trim() : null
      if (redirectUrl) {
        try {
          if (typeof window === 'undefined' || !window.location) {
            return
          }

          // validate absolute URL using current location as base
          const parsed = new URL(redirectUrl, window.location.href)
          const parsedHost =
            parsed && parsed.hostname ? parsed.hostname.toLowerCase() : ''

          // don't redirect if it's the same URL or any turbodebt.com host (including subdomains)
          if (
            parsed.href === window.location.href ||
            parsedHost.endsWith('turbodebt.com')
          ) {
            return
          }

          window.location.href = redirectUrl
        } catch (err) {
          console.warn(
            'redirectToDownsell: invalid redirect URL from server',
            redirectUrl,
            err,
          )
        }
      }
    }
  } catch (error) {
    console.error(error)
  }
}
